import React from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import Home from "./pages/index";
import About from "./pages/about/About";
import AboutSankofa from "./pages/about/Sankofa";
import History from "./pages/history/History";
import ACCRPandEJI from "./pages/history/ACCRPEJI";
import RacialTerror from "./pages/history/RacialTerror";
import InMemoriam2Filters from "./pages/inMemoriam/InMemoriam2Filters";
import InMemoriamLocationFilter from "./pages/inMemoriam/InMemoriamLocationFilter";
import MemorialQuilts from "./pages/inMemoriam/MemorialQuilts";
import SoilExhibitPage from "./pages/inMemoriam/SoilExhibit";
import TraumaInformedResources from "./pages/resources/TraumaInformedResources";
import BlackHeritageFilter from "./pages/blackHeritage/BlackHeritageFilter";
import BlackHeritageDetail from "./pages/blackHeritage/DBHTDetail";
import Calendar from "./pages/calendar/Calendar";
import GetInvolved from "./pages/getInvolved/GetInvolved";

import ACCRPArchivalDocsFunc from "./pages/resources/ACCRPArchivalDocsFunc";


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/sankofa" element={<AboutSankofa />} />
        <Route path="/history" element={<History />} />
        <Route path="/history/accrp-eji" element={<ACCRPandEJI />} />
        <Route path="/history/racial-terror" element={<RacialTerror />} />
        <Route path="/in-memoriam" element={<InMemoriam2Filters />} />
        <Route
          path="/in-memoriam/community-quilts"
          element={<MemorialQuilts />}
        />
       <Route path="/in-memoriam/soil-exhibit" element={<SoilExhibitPage/>} /> 
        <Route path="/resources" element={<ACCRPArchivalDocsFunc />} />
        <Route
          path="/resources/trauma-informed"
          element={<TraumaInformedResources />}
        />
        <Route path="/black-heritage" element={<BlackHeritageFilter />} />
        <Route
          exact
          path="/black-heritage-trail/:siteid"
          element={<BlackHeritageDetail />}
        />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/get-involved" element={<GetInvolved />} />
      </Routes>
    </div>
  );
}

export default App;
